export const HomeVideo = require('./output.mp4') 
